import React from "react"

import { Route, BrowserRouter as Router, Routes } from "react-router-dom"

import { ThemeProvider, useMediaQuery } from "@mui/material"

import { Oups } from "./clux-ui/scenes"
import { ROUTES } from "./config/routes"
import { PAGES } from "./enums/pages"
import { MainLayout } from "./layouts"
import {
  Blog,
  ChoixAtelier,
  DetectiveCluxHalloween,
  EnqueteNoel,
  Homepage,
  LectureFlash,
  Materiel,
  Outils,
  StyleGuide,
} from "./scenes"
import { theme } from "./style/theme"

import "./App.scss"

// TODO _ charger les composants en async

const App = () => {
  const isResponsive = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <div className={`app${isResponsive ? " is-responsive" : ""}`}>
      <ThemeProvider theme={theme}>
        <Router>
          <MainLayout>
            <Routes>
              <Route
                path={ROUTES[PAGES.ATELIERS].path}
                element={<ChoixAtelier />}
              />
              <Route
                path={ROUTES[PAGES.ATELIER_LECTURE_FLASH].path}
                element={<LectureFlash />}
              />
              <Route
                path={ROUTES[PAGES.ATELIER_ENQUETE_NOEL].path}
                element={<EnqueteNoel />}
              />
              <Route
                path={ROUTES[PAGES.ATELIER_DETECTIVE_CLUX_HALLOWEEN].path}
                element={<DetectiveCluxHalloween />}
              />
              <Route
                path={ROUTES[PAGES.MATERIEL].path}
                element={<Materiel />}
              />
              <Route path={ROUTES[PAGES.OUTILS].path} element={<Outils />} />
              <Route path={ROUTES[PAGES.BLOG].path} element={<Blog />} />
              <Route path={ROUTES.HOME.path} element={<Homepage />} />
              <Route path={ROUTES.STYLEGUIDE.path} element={<StyleGuide />} />
              <Route path="*" element={<Oups />} />
            </Routes>
          </MainLayout>
        </Router>
      </ThemeProvider>
    </div>
  )
}

export default App
